export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_LAST_UPDATE = 'SET_LAST_UPDATE';
export const SET_LAST_UPDATE_HOME = 'SET_LAST_UPDATE_HOME';
export const SET_FORCE_LOAD = 'SET_FORCE_LOAD';
export const SET_CURRENT_SPRINT = 'SET_CURRENT_SPRINT';
